import ModelTypeConstants from 'constants/ModelTypeConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';

import {LeafType} from './BenchlingTypeDef';

export const LEAF_TYPE_TO_ICON: {[key in LeafType]: BenchlingIconName} = {
  [LeafType.BOOLEAN]: 'boolean',
  [LeafType.DATETIME]: 'calendar',
  [LeafType.DATE]: 'calendar',
  [LeafType.DECIMAL]: 'number',
  [LeafType.INTEGER]: 'number',
  [LeafType.JSON]: 'json',
  [LeafType.TEXT]: 'text',

  [LeafType.BENCHLING_OBJECT]: FolderItemIcon.BasicFolderItem,
  [LeafType.BLOB]: 'attachment',
  [LeafType.DROPDOWN_OPTION]: ModelTypeConstants.SCHEMA_FIELD_SELECTOR_OPTION,
  [LeafType.BATCH]: ModelTypeConstants.BATCH,
  [LeafType.CHART]: ModelTypeConstants.CHART,
  [LeafType.FILE]: ModelTypeConstants.FILE,
  [LeafType.SCRATCH_FILE]: ModelTypeConstants.SCRATCH_FILE,
  [LeafType.DATA_FRAME]: ModelTypeConstants.DATA_FRAME,
  [LeafType.DATASET]: ModelTypeConstants.DATASET,
  [LeafType.BIOENTITY]: ModelTypeConstants.BIOENTITY_MIXIN,
  [LeafType.BASIC_FOLDER_ITEM]: FolderItemIcon.BasicFolderItem,
  [LeafType.MIXTURE]: FolderItemIcon.Mixture,
  [LeafType.MOLECULE]: FolderItemIcon.Molecule,
  [LeafType.PROTEIN]: FolderItemIcon.Protein,
  [LeafType.SEQUENCE]: FolderItemIcon.Sequence,
  [LeafType.ENTRY]: FolderItemIcon.Entry,
  [LeafType.PROTOCOL]: ModelTypeConstants.PROTOCOL,
  [LeafType.REQUEST]: ModelTypeConstants.REQUEST,
  [LeafType.RESULT]: 'table',
  [LeafType.RUN]: ModelTypeConstants.ASSAY_RUN,
  [LeafType.STORABLE]: 'fridge',
  [LeafType.BOX]: ModelTypeConstants.BOX,
  [LeafType.CONTAINER]: ModelTypeConstants.CONTAINER,
  [LeafType.LOCATION]: ModelTypeConstants.LOCATION,
  [LeafType.PLATE]: ModelTypeConstants.PLATE,
  [LeafType.PROCESS]: ModelTypeConstants.PROCESS,
  [LeafType.PROCESS_TASK]: ModelTypeConstants.PROCESS_TASK,
  [LeafType.PROCESS_OUTPUT]: ModelTypeConstants.PROCESS_OUTPUT,
  [LeafType.STUDY]: ModelTypeConstants.STUDY,
  [LeafType.TEAM]: ModelTypeConstants.TEAM,
  [LeafType.TEST_ORDER]: ModelTypeConstants.TEST_ORDER,
  [LeafType.USER]: ModelTypeConstants.USER,
};
